import React from 'react';
import * as S from './style';
import { FormProfile, ItemInfo, ItemInfoContainer } from 'components';
import { ReactComponent as IcOwner } from 'assets/img/profile/ic_owner.svg';
import { LABEL_NAME, LABEL_ROLE, LABEL_TEL, LABEL_BIRTHDAY } from 'commons/ZimssaString';
import { getPhoneWithHyphen, getBirthdayWithDot } from 'commons/ZimssaHelper';

interface Props {
    profileImage: string;
    name: string;
    phone: string;
    isOwner: boolean;
    birthday: string;
}

function MyProfile({ profileImage, name, phone, isOwner, birthday }: Props): React.ReactElement {
    return (
        <S.MyProfile>
            <S.ProfileImageWrapper>
                <FormProfile value={profileImage} name={name} subName={'파트너'} phone={getPhoneWithHyphen(phone)} />
            </S.ProfileImageWrapper>
            <ItemInfoContainer>
                <ItemInfo title={LABEL_NAME} contents={name} />
                <ItemInfo
                    title={LABEL_ROLE}
                    contents={
                        isOwner ? (
                            <S.LabelOwnerWrapper>
                                <S.SvgOwnerWrapper>
                                    <IcOwner />
                                </S.SvgOwnerWrapper>
                                소장
                            </S.LabelOwnerWrapper>
                        ) : ( '직원' )
                    }
                />
                <ItemInfo title={LABEL_TEL} contents={getPhoneWithHyphen(phone)} />
                <ItemInfo title={LABEL_BIRTHDAY} contents={getBirthdayWithDot(birthday)} />
            </ItemInfoContainer>
        </S.MyProfile>
    );
}

export default MyProfile;
